import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import PageRootWrapper from '../../components/common/PageRoot/PageRootWrapper';
import CompanyReportWrapper from '../../components/CompanyReport/CompanyReportWrapper';

const CompanyReport = ({ location }) => (
    <PageRootWrapper location={location}>
        <CompanyReportWrapper />
    </PageRootWrapper>
);

CompanyReport.propTypes = {
    location: ReactRouterPropTypes.location.isRequired,
};

export default CompanyReport;
